export default __webpack_public_path__ + "static/Card20-dc893ef386bf73b24934de69a0133567.png";